import React, { useEffect, useState } from 'react';
import {
    Box, Button, Collapse, IconButton, Table,
    TableBody, TableCell, TableHead, TableRow, Tooltip
} from '@mui/material';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import { CommonPatientDetails } from '../../../Components/Common Components/CommonComponents';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import { CurrencySymbol } from '../../../Utility/Constants';
import { AmountFormat, formatDate } from '../../../Components/CommonFunctions/CommonFunctions';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { getCachevalue } from '../../../Utility/Services/CacheProviderService';
import { Colors } from '../../../Styles/Colors';

const DocReceipts = () => {
    const [states, setStates] = useState({
        patientDetails: {},
        clinic_id: null,
        appointment_id: null,
        patient_id: null,
        doctor_id: null,
        selectedIndex: null,
        receiptData: [],
    });

    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    });

    const errorMessage = (msg) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: msg,
        });
    };

    const successMessage = (msg) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: msg,
        });
    };

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
        });
    };

    useEffect(() => {
        const clinicId = getCachevalue('SelectedDoctorClinic');
        const appointmentData = JSON.parse(getCachevalue('DoctorPatientData'));

        const updateStates = {
            clinic_id: clinicId,
            appointment_id: appointmentData?.appointment_id,
            patient_id: appointmentData?.patient_id,
            doctor_id: appointmentData?.doctor_id,
            patientDetails: appointmentData,
        };

        setStates((prev) => ({ ...prev, ...updateStates }));
        getPatientDetailData(updateStates.patient_id);
        getReceiptBillData(updateStates.patient_id);
    }, []);

    const getPatientDetailData = (patient_id) => {
        try {
            RestAPIService.getAll(`${Serviceurls.DOC_PATIENT_DETAIL_GET}?patient_id=${patient_id}`)
                .then((res) => {
                    if (res?.data?.status === 'success') {
                        setStates((prev) => ({ ...prev, patientDetails: {...prev.patientDetails, ...res.data.data }}));
                    }
                }).catch((err) => {
                    errorMessage(err?.response?.data?.message || err.message);
                });
        } catch (error) {
            errorMessage(error.message)
        }
    };

    const getReceiptBillData = (patient_id) => {
        try {
            RestAPIService.getAll(`${Serviceurls.NEW_FO_RECEIPT_BILL}?patient_id=${patient_id}`)
                .then((res) => {
                    if (res?.data?.status === 'success') {
                        setStates((prev) => ({ ...prev, receiptData: res.data.data }));
                    }
                }).catch((err) => {
                    errorMessage(err?.response?.data?.message || err.message);
                });
        } catch (error) {
            errorMessage(error.message)
        }
    };

    const getReceiptBillPrint = (id) => {
        try {
            const clinicId = getCachevalue('SelectedDoctorClinic');
            RestAPIService.getAll(`${Serviceurls.NEW_RECEIPT_INDIV_PRINT}?module_type=OP&receipt_id=${id}&clinic_id=${clinicId}`)
                .then((response) => {
                    const file = new Blob([response.data], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((err) => {
                    errorMessage(err?.response?.data?.message || err.message);
                });
        } catch (error) {
            errorMessage(error.message)
        }
    };

    const renderTableTwo = (i, secondIndex) => {
        return (
            <><TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                <Collapse
                    in={states.selectedIndex === secondIndex}
                    timeout={'auto'}
                >
                    <Box margin={1} className='eMed_Pat_Bill_Tbl_Two'>
                        <Table>
                            <TableHead>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Date And Time")}</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Receipt Number")}</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Payment Mode Type")}</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Receipt Type")}</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Paid In")}</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Created By")}</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header' align='center'>{("Description")}</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header' align='right'>{("Total Paid Amount")}</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header' align='center'>{("Action")}</TableCell>
                            </TableHead>
                            <TableBody>
                                {i?.receipt_data?.length > 0 ? i.receipt_data.map((val, thirdIndex) => (
                                    <TableRow key={thirdIndex}>
                                        <TableCell className='eMed_Pat_Tbl_one_style'>{val?.receipt_date ? val.receipt_date : "-"}</TableCell>
                                        <TableCell className='eMed_Pat_Tbl_one_style'>{val?.receipt_number ? val.receipt_number : "-"}</TableCell>
                                        <TableCell className='eMed_Pat_Tbl_one_style'>{val?.payment_mode_types ? val.payment_mode_types : "Not Applicable"}</TableCell>
                                        <TableCell className='eMed_Pat_Tbl_one_style'>{val?.receipt_for ? val.receipt_for : '-'}</TableCell>
                                        <TableCell className='eMed_Pat_Tbl_one_style'>{val?.collected_in ? val.collected_in : '-'}</TableCell>
                                        <TableCell className='eMed_Pat_Tbl_one_style'>{val?.created_by ? val.created_by : "-"}</TableCell>
                                        <TableCell className='eMed_Pat_Tbl_one_style' align='center'>{val?.description ?
                                            val?.description ? val?.description?.length > 30 ?
                                                <Tooltip placement='top' title={val?.description} arrow>
                                                    <div style={{ fontSize: "0.875rem" }}>{val?.description.slice(0, 28) + "..."}</div></Tooltip> :
                                                <div style={{ fontSize: "0.875rem" }}>{val?.description}</div> : "-"
                                            : '-'}</TableCell>                                        <TableCell className='eMed_Pat_Tbl_one_style' align='right'>{val?.amount_received ? AmountFormat((val?.receipt_for === "Cancelled" || val?.receipt_for === "Refund") ? (val.amount_received * -1) : val.amount_received)?.replace(`${CurrencySymbol}`, "") : "0"}</TableCell>
                                        <TableCell className='eMed_Pat_Tbl_one_style' sx={{ display: 'flex', justifyContent: "center", alignItems: "center" }}>
                                            <Button className='eMed_Pat_tbl_two_btn'>
                                                <Tooltip placement='top' title={'Print'} arrow>
                                                    <img
                                                        onClick={() => { getReceiptBillPrint(val?.id) }}
                                                        src={ImagePaths.PrintIcons.default} className='eMed_Pat_Bill_img' alt='credit' />
                                                </Tooltip>
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                )) : <TableRow><TableCell align='center' colSpan={9}>No Records To Be Shown</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell></>
        )
    }

    const renderReceiptTable = () => (
        <Box component="div" sx={{ backgroundColor: Colors.white }}>
            <Table aria-label="collapsible table" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell className='eMed_Pat_Bill_Tbl_Header' />
                        <TableCell className='eMed_Pat_Bill_Tbl_Header'>{("Appointment Number And Date")}</TableCell>
                        <TableCell className='eMed_Pat_Bill_Tbl_Header' align='right'>{("No Of Receipts")}</TableCell>
                        <TableCell className='eMed_Pat_Bill_Tbl_Header' align='center'>{`${("Total Paid Amount")} (${CurrencySymbol})`}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {states.receiptData?.length > 0 ? states.receiptData.map((item, firstIndex) => (
                        <><TableRow
                            sx={{ backgroundColor: states.selectedIndex === firstIndex ? Colors?.ThemeLightColor : 'white', cursor: 'pointer' }}
                            key={firstIndex}
                            onClick={() => {
                                setStates((prev) => ({ ...prev, selectedIndex: states.selectedIndex === firstIndex ? null : firstIndex }))
                            }}>
                            <TableCell className='eMed_Pat_Tbl_one_style'>
                                <IconButton
                                    size='small'
                                    onClick={() => {
                                        setStates((prev) => ({ ...prev, selectedIndex: states.selectedIndex === firstIndex ? null : firstIndex }))
                                    }}
                                >
                                    {states.selectedIndex === firstIndex ?
                                        <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </IconButton>
                            </TableCell>
                            <TableCell className='eMed_Pat_Tbl_one_style'>{`${item?.appointment_number ? item?.appointment_number : "-"} 
                                | ${item?.appointment_date ? formatDate(item?.appointment_date) : "-"}`}</TableCell>
                            <TableCell className='eMed_Pat_Tbl_one_style' align='right'>{item?.receipt_count ? item?.receipt_count : "-"}</TableCell>
                            <TableCell className='eMed_Pat_Tbl_one_style' align='center'>{item?.total_receipt_amount ? AmountFormat(item?.total_receipt_amount)?.replace(`${CurrencySymbol}`, "") : "0"}</TableCell>
                        </TableRow>
                            <TableRow>
                                {renderTableTwo(item, firstIndex)}
                            </TableRow></>
                    )) : <TableRow><TableCell align='center' colSpan={4}>No Records to Be Shown</TableCell></TableRow>}
                </TableBody>
            </Table>
        </Box>
    );

    return (
        <Box component="div" sx={{ backgroundColor: Colors.Background, height: '75dvh' }}>
            <Box>
                <Box display="flex">
                    <Box className="doc_header_card" ml="0.5rem">
                        <CommonPatientDetails data={states.patientDetails} showDetailed fromDoctor />
                    </Box>
                </Box>
                <Box maxHeight="64dvh" border="1px solid lightgray" m="0.5rem" overflow="auto">
                    {renderReceiptTable()}
                </Box>
            </Box>
            {message.isErrorMsg && (
                <ToastMsg severity="error" msg={message.isErrorMsgText} msgPop={msgClose} />
            )}
            {message.successMsg && (
                <ToastMsg severity="success" msg={message.successMsgText} msgPop={msgClose} />
            )}
        </Box>
    );
};

export default DocReceipts;
